export const TOGGLE_LOADER="TOGGLE_LOADER"
export const SET_ERROR_MESSAGE="SET_ERROR_MESSAGE"
export const SET_DEFAULT_ORGANIZATION_ID="SET_DEFAULT_ORGANIZATION_ID"
export const SET_DEFAULT_PROJECT_ID ="SET_DEFAULT_PROJECT_ID"
export const SET_DEFAULT_ENV_TYPE ="SET_DEFAULT_ENV_TYPE"